import { FieldNames as BuyItAgainFieldNames } from './buy-it-again.constants';
import { FieldNames as FrequentlyBoughtTogetherFieldNames } from './frequently-bought-together.constants';
import { FieldNames as OthersYouMayLikeFieldNames } from './others-you-may-like.constants';
import { BusinessObjectiveOptions, FieldNames as RecommendedForYouFieldNames } from './recommended-for-you.constants';
import { FieldNames as OnSaleFieldNames } from './on-sale.constants';
import { FieldNames as SimilarItemsFieldNames } from './similar-items.constants';
export var ModelTypeOption;
(function (ModelTypeOption) {
    ModelTypeOption["RecentlyViewed"] = "recently-viewed";
    ModelTypeOption["RecommendedForYou"] = "recommended-for-you";
    ModelTypeOption["FrequentlyBoughtTogether"] = "frequently-bought-together";
    ModelTypeOption["BuyItAgain"] = "buy-it-again";
    ModelTypeOption["OthersYouMayLike"] = "others-you-may-like";
    ModelTypeOption["SimilarItems"] = "similar-items";
    ModelTypeOption["OnSaleItems"] = "on-sale-items";
    // API supported but not yet implemented in UI
    // PageOptimization = 'page-optimization',
})(ModelTypeOption || (ModelTypeOption = {}));
export var BusinessObjectiveOption;
(function (BusinessObjectiveOption) {
    BusinessObjectiveOption["ClickThroughRate"] = "ctr";
    BusinessObjectiveOption["ConversionRate"] = "cvr";
    BusinessObjectiveOption["RevenuePerSession"] = "revenue-per-order";
})(BusinessObjectiveOption || (BusinessObjectiveOption = {}));
export var FieldNames;
(function (FieldNames) {
    FieldNames["ModelTypes"] = "type";
})(FieldNames || (FieldNames = {}));
export const defaultFormValues = {
    [FieldNames.ModelTypes]: null,
};
export const modelTypes = [{
        name: 'RECS_MODEL_STEP_MODEL_TYPE_RECENTLY_VIEWED',
        description: '',
        value: ModelTypeOption.RecentlyViewed,
    }, {
        name: 'RECS_MODEL_STEP_MODEL_TYPE_RECOMMENDED_FOR_YOU',
        description: 'RECS_MODEL_STEP_MODEL_TYPE_RECOMMENDED_FOR_YOU_DESCRIPTION',
        value: ModelTypeOption.RecommendedForYou,
    }, {
        name: 'RECS_MODEL_STEP_MODEL_TYPE_OTHERS_YOU_MAY_LIKE',
        description: 'RECS_MODEL_STEP_MODEL_TYPE_OTHERS_YOU_MAY_LIKE_DESCRIPTION',
        value: ModelTypeOption.OthersYouMayLike,
    }, {
        name: 'RECS_MODEL_STEP_MODEL_TYPE_FREQUENTLY_BOUGHT_TOGETHER',
        description: 'RECS_MODEL_STEP_MODEL_TYPE_FREQUENTLY_BOUGHT_TOGETHER_DESCRIPTION',
        value: ModelTypeOption.FrequentlyBoughtTogether,
    }, {
        name: 'RECS_MODEL_STEP_MODEL_TYPE_SIMILAR_ITEMS',
        description: 'RECS_MODEL_STEP_MODEL_TYPE_SIMILAR_ITEMS_DESCRIPTION',
        value: ModelTypeOption.SimilarItems,
    }, {
        name: 'RECS_MODEL_STEP_MODEL_TYPE_BUY_IT_AGAIN',
        description: 'RECS_MODEL_STEP_MODEL_TYPE_BUY_IT_AGAIN_DESCRIPTION',
        value: ModelTypeOption.BuyItAgain,
    }, {
        name: 'RECS_MODEL_STEP_MODEL_TYPE_ON_SALE',
        description: 'RECS_MODEL_STEP_MODEL_TYPE_ON_SALE_DESCRIPTION',
        value: ModelTypeOption.OnSaleItems,
    }];
export const dataRequirementsByModelType = {
    [ModelTypeOption.RecommendedForYou]: [
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.RecommendedForYou}${BusinessObjectiveOptions.ClickThroughRate}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.RecommendedForYou}${BusinessObjectiveOptions.ConversionRate}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.RecommendedForYou}${BusinessObjectiveOptions.RevenuePerOrder}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
    [ModelTypeOption.OthersYouMayLike]: [
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.OthersYouMayLike}${BusinessObjectiveOptions.ClickThroughRate}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.OthersYouMayLike}${BusinessObjectiveOptions.ConversionRate}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.OthersYouMayLike}${BusinessObjectiveOptions.RevenuePerOrder}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
    ],
    [ModelTypeOption.FrequentlyBoughtTogether]: [
        'RECS_MODEL_DATA_REQUIREMENTS_10_OCCURENCES_OR_90_DAYS_PURCHASES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_PURCHASED_IN_1_YEAR',
        'RECS_MODEL_DATA_REQUIREMENTS_1000_PURCHASES_IN_1_YEAR',
    ],
    [`${ModelTypeOption.FrequentlyBoughtTogether}${BusinessObjectiveOptions.RevenuePerOrder}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_10_OCCURENCES_OR_90_DAYS_PURCHASES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_PURCHASED_IN_1_YEAR',
        'RECS_MODEL_DATA_REQUIREMENTS_1000_PURCHASES_IN_1_YEAR',
    ],
    [ModelTypeOption.SimilarItems]: [
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_100_SKUS',
    ],
    [ModelTypeOption.BuyItAgain]: [
        'RECS_MODEL_DATA_REQUIREMENTS_10_OCCURENCES_OR_90_DAYS_PURCHASES_OR_60_DAYS_PURCHASE',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_FOR_PURCHASE_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_1000_PURCHASES_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_100_SKUS',
    ],
    [ModelTypeOption.OnSaleItems]: [
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.OnSaleItems}${BusinessObjectiveOptions.ClickThroughRate}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
    [`${ModelTypeOption.OnSaleItems}${BusinessObjectiveOptions.ConversionRate}`]: [
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_ADD_TO_CARD_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_DAYS_OCCURRENCES',
        'RECS_MODEL_DATA_REQUIREMENTS_UNIQUE_100_CATALOG_ITEMS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_DETAIL_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_7_DAYS_OF_VIEWS_IN_90_DAYS',
        'RECS_MODEL_DATA_REQUIREMENTS_MINIMUM_10_000_HOME_VIEWS_IN_90_DAYS',
    ],
};
export const fieldNamesByModelType = {
    [ModelTypeOption.BuyItAgain]: BuyItAgainFieldNames,
    [ModelTypeOption.OnSaleItems]: OnSaleFieldNames,
    [ModelTypeOption.FrequentlyBoughtTogether]: FrequentlyBoughtTogetherFieldNames,
    [ModelTypeOption.OthersYouMayLike]: OthersYouMayLikeFieldNames,
    [ModelTypeOption.RecommendedForYou]: RecommendedForYouFieldNames,
    [ModelTypeOption.SimilarItems]: SimilarItemsFieldNames,
};
